<app-score-dashboard
    [title]="'MHE Checklist Compliance'"
    [trendingTitle]="'MHE Compliance Trending'"
    [centerText]="'My Score'"
    [employeeId]="employeeId"
    [daysLookBack]="daysLookBack"
    [palette]="palette"
    [showScore]="true"
    [showTrending]="true"
    [loadScoreData]="loadScoreData"
    [loadTrendingData]="loadTrendingData"
    [exportData]="exportData">
</app-score-dashboard>
